<script setup>
  import { computed, ref } from "vue";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { ChartColumn, Settings, Target } from "lucide-vue-next";
  import AppSidebar from "@/components/App/Sidebar/AppSidebar.vue";
  import { userType } from "@utils/constants/userRoles";
  import { usePricerProjectStore } from "@stores/pricer/pricerProject";
  import { useCurrentUserStore } from "@stores/currentUser.js";

  const { user } = storeToRefs(useCurrentUserStore());

  const pricerProjectStore = usePricerProjectStore();
  const { project } = storeToRefs(pricerProjectStore);
  const projectToken = computed(() => project.value?.token);

  const route = useRoute();

  const hasAdminOrSalesRole = [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES].includes(user.value?.user_type);

  const navigation = computed(() => [
    {
      title: "Project",
      isOpen: ref(true),
      items: [
        {
          title: "General",
          url: `/admin/pricer/projects/${projectToken.value}/settings`,
          icon: Settings,
          isActive: !!route.path.match(/^\/admin\/pricer\/projects\/(.*)\/settings/),
          if: hasAdminOrSalesRole,
        },
        {
          title: "Targets",
          url: `/admin/pricer/projects/${projectToken.value}/targets`,
          icon: Target,
          isActive: !!route.path.match(/^\/admin\/pricer\/projects\/(.*)\/targets/),
          if: hasAdminOrSalesRole,
        },
        {
          title: "Summary",
          url: `/admin/pricer/projects/${projectToken.value}/summary`,
          icon: ChartColumn,
          isActive: !!route.path.match(/^\/admin\/pricer\/projects\/(.*)\/summary/),
          if: hasAdminOrSalesRole,
        },
      ],
    },
  ]);
</script>

<template>
  <AppSidebar
    :navigation="navigation"
    :back="{ label: 'Pricer', to: '/admin/pricer/projects' }" />
</template>
